/** Brief 12, `Vazifalar`. */
export const ruB12Tasks = {
  "tasks.title": "Задачи",
  "tasks.head.overdue": "просрочено: {count}",
  "tasks.head.today": "сегодня: {count}",
  "tasks.head.open": "открыто: {count}",
  "tasks.scope.label": "Чьи задачи",
  "tasks.scope.mine": "Мои",
  "tasks.scope.allBranches": "Все филиалы",
  "tasks.scope.branch": "Филиал",
  "tasks.new": "Задача",
  "tasks.chips.label": "Тип задачи",
  "tasks.chip.all": "Все",
  "tasks.chip.call": "Звонок",
  "tasks.chip.message": "Сообщение",
  "tasks.chip.document": "Документ",
  "tasks.chip.payment": "Оплата",
  "tasks.chip.followUp": "Повторный контакт",
  "tasks.chip.ai": "Kapitan AI",
  "tasks.kind.other": "Другое",
  "tasks.showDone": "Выполненные",
  "tasks.group.overdue": "Просрочено",
  "tasks.group.today": "Сегодня",
  "tasks.group.tomorrow": "Завтра",
  "tasks.group.later": "Позже",
  "tasks.group.done": "Выполнено",
  "tasks.group.cancelled": "Отменено",
  "tasks.due.yesterday": "Вчера",
  "tasks.due.today": "Сегодня",
  "tasks.due.tomorrow": "Завтра",
  "tasks.origin.booking": "Брони · срок оплаты",
  "tasks.origin.thread": "Переписки",
  "tasks.origin.rule": "Правило напоминания",
  "tasks.origin.note": "Есть заметка",
  "tasks.tick": "Отметить выполненной",
  "tasks.closedTick": "Закрытая задача не открывается снова",
  "tasks.doneToast": "Выполнено: {title}",
  "tasks.failed": "Не удалось закрыть задачу: {reason}",
  "tasks.edit.save": "Сохранить",
  "tasks.edit.cancelTask": "Отменить задачу",
  "tasks.edit.saved": "Задача сохранена",
  "tasks.edit.failed": "Не удалось сохранить задачу",
  "tasks.edit.pastDue": "Новый срок должен быть позже текущего времени.",
  "tasks.cancel.title": "Отмена задачи",
  "tasks.cancel.reason": "Причина",
  "tasks.cancel.close": "Закрыть",
  "tasks.cancel.confirm": "Отменить",
  "tasks.cancel.failed": "Не удалось отменить задачу",
  "tasks.empty.title": "Задач нет",
  "tasks.empty.message": "Дела на сегодня выполнены. Новая задача придёт из сделки, переписки или правила напоминания.",
  "tasks.empty.action": "К сделкам",
  "tasks.filterEmpty.title": "На сегодня всё выполнено",
  "tasks.filterEmpty.message": "В этом фильтре открытых задач не осталось.",
  "tasks.filterEmpty.action": "Сбросить фильтр",
  "tasks.error.title": "Задачи не загрузились",
  "tasks.error.message": "Сервер не ответил. Введённые данные сохранены, страницу можно безопасно перезагрузить.",
  "tasks.error.status": "Состояние системы",
  "tasks.denied.message": "Эта роль не видит задачи. При необходимости напишите владельцу агентства.",
  "tasks.truncated": "Показаны ближайшие задачи: {count}. Сузьте список по типу или филиалу.",
  "tasks.form.title": "Новая задача",
  "tasks.form.text": "Что нужно сделать",
  "tasks.form.textHint": "Например, позвонить Малике",
  "tasks.form.textRequired": "Введите текст задачи",
  "tasks.form.type": "Тип",
  "tasks.form.date": "Дата",
  "tasks.form.time": "Время",
  "tasks.form.subject": "Клиент или сделка",
  "tasks.form.subjectHint": "Имя или №",
  "tasks.form.assignee": "Ответственный",
  "tasks.form.note": "Заметка",
  "tasks.form.noteHint": "Например, просил позвонить вечером",
  "tasks.form.cancel": "Отмена",
  "tasks.form.save": "Сохранить",
  "tasks.form.added": "Задача добавлена",
  "tasks.form.failed": "Не удалось добавить задачу",
} as const;
